import { Head, Form as InertiaForm, Link } from "@inertiajs/react";
import AuthLayout from "@/layout/AuthLayout.tsx";
import { Button } from "@/components/ui/button.tsx";
import { Input } from "@/components/ui/input.tsx";
import { Label } from "@/components/ui/label.tsx";

type PasswordNewProps = {
  email?: string;
};

const New = ({ email }: PasswordNewProps) => {
  return (
    <>
      <Head title="Mot de passe oublie" />
      <div className="space-y-6">
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-[0.35em] text-muted-foreground">Recuperation</p>
          <h1 className="text-3xl font-semibold">Mot de passe oublie</h1>
          <p className="text-sm text-muted-foreground">
            Recevez un lien pour definir un nouveau mot de passe.
          </p>
        </div>

        <InertiaForm
          method="post"
          action="/users/password"
          transform={(data) => ({ user: data })}
          className="space-y-4"
        >
          {({ errors, processing }) => (
            <>
              <div className="space-y-2">
                <Label htmlFor="email">Adresse email</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  placeholder="prenom.nom@taxio.app"
                  defaultValue={email || ""}
                />
                {errors.email && (
                  <p className="text-xs text-red-500">{errors.email.join(", ")}</p>
                )}
              </div>

              <Button type="submit" className="w-full" disabled={processing}>
                {processing ? "Envoi..." : "Envoyer le lien"}
              </Button>
            </>
          )}
        </InertiaForm>

        <div className="text-sm text-muted-foreground">
          <Link href="/users/sign_in" className="text-primary hover:underline">
            Retour a la connexion
          </Link>
        </div>
      </div>
    </>
  );
};

New.layout = (page: React.ReactNode) => <AuthLayout>{page}</AuthLayout>;

export default New;
